const USER_KEY = "hm_user";
const PROFILE_KEY = "hm_profile";
const THEME_KEY_PREFIX = "hm_theme_preference";
export const DEFAULT_THEME = "default";
export const WINTER_ARC_THEME = "winter_arc";

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setUser(u) {
  localStorage.setItem(USER_KEY, JSON.stringify(u));
}

export function isWinterArcEligible(user) {
  return Boolean(
    user?.subscriptionTier === "winter_arc"
    && (user?.entitlements?.winterArc || user?.entitlements?.winter_arc),
  );
}

function themeKey(user) {
  const identity = user?.id || user?.userId || user?.email || "anonymous";
  return `${THEME_KEY_PREFIX}:${identity}`;
}

export function getThemePreference(user) {
  const eligible = isWinterArcEligible(user);
  try {
    const saved = localStorage.getItem(themeKey(user));
    if (saved === DEFAULT_THEME) return DEFAULT_THEME;
    if (saved === WINTER_ARC_THEME && eligible) return WINTER_ARC_THEME;
  } catch {
    // Use the entitlement-aware default when storage is unavailable.
  }
  return eligible ? WINTER_ARC_THEME : DEFAULT_THEME;
}

export function setThemePreference(user, theme) {
  const allowedTheme = theme === WINTER_ARC_THEME && isWinterArcEligible(user)
    ? WINTER_ARC_THEME
    : DEFAULT_THEME;
  localStorage.setItem(themeKey(user), allowedTheme);
  window.dispatchEvent(new CustomEvent("hm-theme-change", { detail: { theme: allowedTheme } }));
  return allowedTheme;
}

export function clearUser() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(PROFILE_KEY);
  localStorage.removeItem("hm_access_token");
  localStorage.removeItem("hm_frontend_preview");
  localStorage.removeItem("hm_ob_step");
  localStorage.removeItem("hm_ob_step_key");
}

export function clearSessionKeepProfile() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem("hm_access_token");
  localStorage.removeItem("hm_frontend_preview");
  localStorage.removeItem("hm_ob_step");
  localStorage.removeItem("hm_ob_step_key");
}

export function getProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveProfile(p) {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(p));
  window.dispatchEvent(new CustomEvent("hm-profile-change", { detail: { profile: p } }));
}

export function clearProfile() {
  localStorage.removeItem(PROFILE_KEY);
}

export function isProfileComplete() {
  const p = getProfile();
  return !!(p && (p.completedAt || p.isComplete));
}
